export const Resume = 'https://drive.google.com/file/d/1ipHfSJjmboqvwBQVZG132SRppLERuGQ9/view?usp=sharing';
// 'https://drive.google.com/file/d/1dpl49mfj_77TOeH4JmwTpHuCUwK2NXcw/view?usp=sharing';
// https://drive.google.com/file/d/1YIoqMsbTN-GTmlP-_E5Fsr4o71QeAc6s/view?usp=sharing;
// 'https://drive.google.com/file/d/1y8_xQIK77iQlHtvrXUag19V8NkrQ5TdL/view?usp=sharing';